<template>
  <div class="search-container flex align-center">
    <el-input
      class="search-nav-bar"
      v-model="course_id"
      clearable
      placeholder="Enter the course name"
      @keyup.enter.native="handleChangeCourses"
    >
    </el-input>
    <button @click="handleChangeCourses" class="btn-search">
      Search
    </button>
  </div>
</template>
<script>
import CoursesResource from "../../api/courses";
import { isEmpty } from "@/utils/validate";
export default {
  name: "SearchNavBar",
  props: {
    tag: {
      type: String,
      default: "span"
    }
  },
  data() {
    return {
      course_id: null,
      loading: false,
      options: []
    };
  },
  methods: {
    onGetList(keyword) {
      const body = {
        page: 1,
        limit: 30,
        keyword
      };
      this.loading = true;
      CoursesResource.Lists(body)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.options = data?.data.map(i => ({
              value: i.course_id,
              label: i.headline
            }));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeCourses() {
      // if (isEmpty(this.course_id)) {
      //   this.$message.warning("Vui lòng tìm kiếm khóa học.");
      //   return;
      // }
      // this.$router.push({
      //   name: "Courses",
      //   params: {
      //     keyword: this.course_id
      //   }
      // });
      this.$emit("change-select-courses", this.course_id);
    },
    remoteMethod(query) {}
  }
};
</script>
<style>
.search-nav-bar .el-input__inner {
  min-height: 40px;
  border-radius: 50px !important;
  max-width: 450px;
  width: 100%;
  padding-right: 110px !important;
}
.search-nav-bar .el-input__suffix {
  right: 80px;
}
.search-nav-bar .el-input__inner::placeholder {
  font-size: 14px;
}
</style>
<style scoped>
.search-container {
  max-width: 450px;
  width: 100%;
  position: relative;
}
.btn-search {
  margin-right: 2px;
  position: absolute;
  background: #035ae0;
  right: 0;
  color: #ffff;
  border-radius: 50px;
  font-size: 12px;
  padding: 5px 15px;
}
</style>
